import type { ResolvedTheme } from '../../theme/resolveTheme';

const HUBSPOT_MESSAGES_CONTAINER_ID = 'hubspot-messages-iframe-container';
const DARK_WIDGET_FILTER = 'invert(1) hue-rotate(180deg)';

declare global {
  interface Window {
    hsConversationsOnReady?: Array<() => void>;
  }
}

/**
 * HubSpot chat is a cross-origin iframe with no dark-theme API. In app dark mode we invert the
 * widget container so the bubble matches; color-scheme stays light to avoid iframe bg artifacts.
 */
export function applyHubSpotChatColorScheme(resolved: ResolvedTheme = 'light'): void {
  const container = document.getElementById(HUBSPOT_MESSAGES_CONTAINER_ID);
  if (!container) {
    return;
  }

  container.style.colorScheme = 'light';
  container.style.filter = resolved === 'dark' ? DARK_WIDGET_FILTER : '';
}

let registered = false;
let observerStarted = false;

export function registerHubSpotChatColorSchemeFix(
  getResolved: () => ResolvedTheme = () => 'light'
): void {
  const apply = () => applyHubSpotChatColorScheme(getResolved());

  apply();

  if (!observerStarted && typeof document !== 'undefined') {
    observerStarted = true;
    const observer = new MutationObserver(apply);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (registered) {
    return;
  }
  registered = true;

  const prior = window.hsConversationsOnReady ?? [];
  window.hsConversationsOnReady = [...prior, apply];
}
